import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TourGuiderDetailsMain from '../Components/Guide/TourGuiderDetailsMain'
import TourGuideInner from '../Components/Guide/TourGuideInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function TourGuiderDetails() {
    return (
        <>
            <SEO 
                title="Tour Guide Details - Tourm Travel Agency"
                description="Meet our professional tour guides and learn about their expertise."
                url="/tour-guide"
            />
            <HeaderOne />
            <Breadcrumb
                title="Tour Guide Details"
            />
            <TourGuiderDetailsMain />
            <TourGuideInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default TourGuiderDetails
